const UNIT_SYSTEMS = {
    metric: {
        weight: {
            label: 'Kilogram (kg)',
            value: 'kg',
            factor: 1
        },
        volume: {
            label: 'Litre (L)',
            value: 'litre',
            factor: 1
        }
    },
    imperial: {
        weight: {
            label: 'Pound (lb)',
            value: 'lb',
            factor: 0.453592
        },
        volume: {
            label: 'Gallon (gal)',
            value: 'gal',
            factor: 3.78541
        }
    }
};

/**
 * Get the units for the unit system.
 * @param {String} system - The unit system (metric or imperial).
 * @return {Array} - The units for the unit system
 */
function getUnitSystemOptions(system = 'metric') {
    if (!UNIT_SYSTEMS[system]) {
        return [];
    }

    return Object.values(UNIT_SYSTEMS[system]);
}

/**
 * Convert the unit and value to the specified unit system.
 * @param {Number} value - The value to convert.
 * @param {String} unit - The unit to convert.
 * @param {String} system - The unit system to convert to.
 * @return {Object} - The converted value and unit in the specified unit system.
 */
function convertToUnitSystem(value = 0, unit, system = 'metric') {
    let convertedValue;
    let convertedUnit;

    if (system === 'imperial') {
        if (['kg', 'KG'].includes(unit)) {
            convertedValue = value / UNIT_SYSTEMS.imperial.weight.factor;
            convertedUnit = UNIT_SYSTEMS.imperial.weight.value;
        } else if (['litre', 'L'].includes(unit)) {
            convertedValue = value / UNIT_SYSTEMS.imperial.volume.factor;
            convertedUnit = UNIT_SYSTEMS.imperial.volume.value;
        }
    } else if (system === 'metric') {
        if (['lb'].includes(unit)) {
            convertedValue = value * UNIT_SYSTEMS.imperial.weight.factor;
            convertedUnit = UNIT_SYSTEMS.metric.weight.value;
        } else if (unit === 'gal') {
            convertedValue = value * UNIT_SYSTEMS.imperial.volume.factor;
            convertedUnit = UNIT_SYSTEMS.metric.volume.value;
        }
    }

    return {
        // round to 3 decimal places to avoid floating point errors
        value: parseFloat(convertedValue || value),
        unit: convertedUnit || unit
    };
}

export { UNIT_SYSTEMS, getUnitSystemOptions, convertToUnitSystem };
